import type { ThemeClasses } from "../../types/components";

// themeClasses estándar de la app Horas Trabajadas (mismo shape que el Modal base).
export const buildThemeClasses = (isDarkMode: boolean): ThemeClasses => ({
  bg: isDarkMode ? "bg-dark-surface" : "bg-white",
  border: isDarkMode ? "border-dark-border" : "border-gray-200",
  text: isDarkMode ? "text-white" : "text-gray-900",
  textSecondary: isDarkMode ? "text-gray-400" : "text-gray-600",
  cardBg: isDarkMode ? "bg-dark-card" : "bg-white",
  cardBorder: isDarkMode ? "border-dark-border" : "border-gray-200",
  buttonHover: isDarkMode ? "hover:bg-dark-card" : "hover:bg-gray-100",
  buttonText: isDarkMode ? "text-gray-400" : "text-gray-600",
  buttonTextHover: isDarkMode ? "hover:text-white" : "hover:text-gray-900",
});

export const inputClass = (isDarkMode: boolean) =>
  `rounded-lg border px-3 py-2 text-sm outline-none transition-colors ${
    isDarkMode
      ? "bg-[#232323] border-dark-border text-white focus:border-violet-500"
      : "bg-white border-gray-300 text-gray-900 focus:border-violet-500"
  }`;

export const DELIVERY_STATUS_TONES: Record<string, string> = {
  sent: "bg-emerald-500/15 text-emerald-500",
  preview: "bg-sky-500/15 text-sky-500",
  not_configured: "bg-gray-400/15 text-gray-500",
  failed: "bg-red-500/15 text-red-500",
};

export const RUN_STATUS_TONES: Record<string, string> = {
  running: "bg-amber-500/15 text-amber-500",
  succeeded: "bg-emerald-500/15 text-emerald-500",
  failed: "bg-red-500/15 text-red-500",
};

/**
 * Tono de la diferencia real − esperado (#969): faltante en rojo (mismo tono que
 * un fallo), al día o con exceso en verde (mismo tono que un éxito).
 */
export const gapTone = (gapHours: number): string => (gapHours < 0 ? RUN_STATUS_TONES.failed : RUN_STATUS_TONES.succeeded);
